module.exports = __webpack_public_path__ + "media/images/emblems/MezzovicoVira-coat_of_arms-0bc06f0961238ef3606a13fcb6f1fafb.svg";